import { render, staticRenderFns } from "./build-version.vue?vue&type=template&id=99c86518&scoped=true"
import script from "./build-version.vue?vue&type=script&lang=js"
export * from "./build-version.vue?vue&type=script&lang=js"
import style0 from "./build-version.vue?vue&type=style&index=0&id=99c86518&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99c86518",
  null
  
)

export default component.exports